/*
 * Метод конвертации json/js объекта в FormData
 */

let buildFormData = function (formData, data, parentKey) {
    if (
        data &&
        typeof data === "object" &&
        !(data instanceof Date) &&
        !(data instanceof File)
    ) {
        Object.keys(data).forEach(key => {
            buildFormData(
                formData,
                data[key],
                parentKey ? `${parentKey}[${key}]` : key
            );
        });
    } else {
        const value = data == null ? "" : data;
        formData.append(parentKey, value);
    }
};

let jsonToFormData = function (data) {
    const formData = new FormData();
    buildFormData(formData, data);
    return formData;
};

export { jsonToFormData };
